const VersionCheck = { getCurrentVersion: () => undefined };

export default VersionCheck;
